import axios from "axios";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Link, useParams } from "react-router-dom";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { all_links } from "../data/links";
import HelmetTags from "../components/HelmetTags";
import LoadingBar from "react-top-loading-bar";
import Card from "../components/Card";

function Solution() {
  const { id, type, class_name, subject, chapter } = useParams();
  const [numPages, setNumPages] = useState(null);
  const [solution, setSolution] = useState();
  const type_h = type.replace(/-/g, " ").toUpperCase();
  const [progress, setProgress] = useState(60);
  const class_h =
    class_name.charAt(0).toUpperCase() + class_name.slice(1).replace(/-/g, " ");
  const subject_h =
    subject.charAt(0).toUpperCase() + subject.slice(1).replace(/-/g, " ");
  const chapter_h =
    chapter.charAt(0).toUpperCase() + chapter.slice(1).replace(/-/g, " ");
  const page_desc = `Get Free ${type_h} for ${class_h} ${subject_h} ${chapter_h}. ${class_h} ${subject_h} ${chapter_h} Ex 1.1, Ex 1.2, Ex 1.3, Ex 1.4, and Miscellaneous Questions ${type_h} are extremely helpful while doing your homework or while preparing for the exam. ${chapter_h} ${class_h} ${subject_h} ${type_h} were prepared according to CBSE marking scheme and guidelines.`;

  const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
  pdfjs.GlobalWorkerOptions.workerSrc = url;
  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .post(`https://cbselearn.onrender.com/read/${id}`)
      .then((response) => setSolution(response.data));
  }, [id]);

  return (
    <div className="page container">
      <HelmetTags
        title={`${type_h} For ${class_h} ${subject_h} ${chapter_h}`}
        desc={page_desc}
        route={`solutions/${type}/${class_name}/${subject}/${chapter}/${id}`}
      />
      <Card title={solution?.chapter} desc={page_desc} sub={class_name} />

      <div className="d-flex mt-5">
        <div className="pdf">
          {solution && (
            <Document
              loading={<LoadingBar color="#000" progress={progress} />}
              className={"PDFDocument"}
              file={solution?.pdf_url}
              onLoadSuccess={({ numPages }) => {
                setNumPages(numPages);
                setProgress(100);
              }}
            >
              {Array.apply(null, Array(numPages))
                .map((x, i) => i + 1)
                .map((page) => (
                  <Page
                    loading={() => setProgress(50)}
                    pageNumber={page}
                    className={"PDFPage"}
                    wrap
                    renderTextLayer={false}
                    scale={1.5}
                  />
                ))}
            </Document>
          )}
        </div>
        <div className="d-none d-lg-block">
          <div className="links">
            <ul>
              {all_links?.map((soution) => (
                <li>
                  <Link to={soution?.link}>{soution?.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Solution;
